import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';

import { getBrandsAction } from '../../app/store/actions/brands';
import { getCategoriesAction } from '../../app/store/actions/categories';
import ProductsAction from '../../app/store/actions/products';
import FIELDS from '../../data/fields';

let productHelper = '';

class ProductsFormComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      product: {
        soneparId: '',
        code: '',
      },
      category: '',
      brandId: '',
      description: '',
      message: '',
      success: '',
      brandName: '',
      categoryName: '',
      isSpot: false,
      spotlight: false,
      isDisable: false,
      otherBrand: false,
      otherDescription: false,
      brandTectag: '',
      descriptionTectag: '',
    };
  }

  componentDidMount() {
    const { productComming } = this.props;

    this.props.getCategories();
    this.props.getBrands();

    if (productComming) {
      this.setState({
        product: {
          soneparId: productComming.soneparId,
          code: productComming.code,
          name: productComming.product.descriptionLarge,
        },
        description: productComming.description,
        brandId: productComming.brandId,
        category: productComming.categoryId,
        categoryName: productComming.category.name,
        brandName: productComming.product.marca,
        isSpot: productComming.isSpot,
        spotlight: productComming.spotlight,
        isDisable: productComming.isDisable,
        otherBrand: (productComming.changeBrandTecTag === true) ? 1 : 0,
        otherDescription: (productComming.changeDescriptionTecTag === true) ? 1 : 0,
        brandTectag: productComming.product.id_marca,
        descriptionTectag: productComming.product.descricao_ecommerce,
      });
    }
  }

  goBack = () => {
    this.props.back.goBack();
  };

  setOnChange = (value) => {
    this.props.getSearchProducts(10, value);
    this.setState({ value });
  };

  setCategory = (id) => {
    this.setState({ category: { id }, message: '', success: '' });
  };

  getSubCategories = categories => categories.map(subCategories => (
    <option key={subCategories.id} value={subCategories.id}>
      {'---- '}
      {subCategories.name}
    </option>
  ));

  getCategories = categories => categories.map(category => (
    <React.Fragment key={category.id}>
      <option key={category.id} value={category.id} disabled>{category.name}</option>
      {category.categories && this.getSubCategories(category.categories)}
    </React.Fragment>
  ));

  getBrandsChangeOptions = () => (
    <React.Fragment>
      <option key={0} value={0}>{I18n.t('no')}</option>
      <option key={1} value={1}>{I18n.t('yes')}</option>
    </React.Fragment>
  );

  getDescriptionChangeOptions = () => (
    <React.Fragment>
      <option key={0} value={0}>{I18n.t('no')}</option>
      <option key={1} value={1}>{I18n.t('yes')}</option>
    </React.Fragment>
  );

  setSelectedProductId = (productCodeTitle) => {
    for (let index = 0; index < this.props.brands.length; index++) {
      const brandObj = this.props.brands[index];

      if (brandObj.id === productHelper.tacTagId.brandId) {
        productHelper.tacTagId.brandDescription = brandObj.description;
      }
    }

    this.setState({
      value: productCodeTitle.value,
      product: { soneparId: productHelper.soneparId, code: productHelper.code },
      description: productHelper.tacTagId.descriptionEcommerce,
      message: '',
      success: '',
      brandId: productHelper.tacTagId.brandId,
      brandName: productHelper.tacTagId.brandDescription,
      descriptionTectag: productHelper.tacTagId.descriptionEcommerce,
    });
  };

  setSelectedProduct = (item) => {
    productHelper = item;
    return `${item.code} ${item.tacTagId.descriptionLarge}`;
  };

  updateProduct = async () => {
    const {
      brandId,
      category,
      description,
      product,
      isSpot,
      spotlight,
      isDisable,
      brandTectag,
      otherBrand,
      otherDescription,
      descriptionTectag,
    } = this.state;

    if (!description) {
      this.setState({ success: '', message: I18n.t('selectDescription') });
    } else {
      try {
        await this.props.updateProduct({
          soneparId: product.soneparId,
          spotlight,
          isSpot,
          categoryId: category.id,
          brandId,
          description,
          code: product.code,
          isDisable,
          brandTectag,
          otherBrand,
          otherDescription,
          descriptionTectag,
        });
        this.setState({ success: I18n.t('productUpdated'), message: '' });
      } catch (err) {
        if (err.response && err.response.data.error.code === 701) {
          this.setState({ success: '', message: I18n.t('tectagProductNotFound') });
        } else if (err.response && err.response.data.error.code === 702) {
          this.setState({ success: '', message: I18n.t('tectagProductBrandNotFound') });
        } else if (err.response && err.response.data.error.code === 1202) {
          this.setState({ success: '', message: I18n.t('categoryNotActivated') });
        } else if (err.response && err.response.data.error.code === 1201) {
          this.setState({ success: '', message: I18n.t('categoryNotFound') });
        } else if (err.response && err.response.data.error.code === 700) {
          this.setState({ success: '', message: I18n.t('productNotFound') });
        } else {
          this.setState({ success: '', message: I18n.t('errorOcurred') });
        }
      }
    }
  };

  saveProduct = async () => {
    const {
      brandId,
      category,
      description,
      product,
      spotlight,
      isSpot,
      isDisable,
      brandTectag,
      otherBrand,
      otherDescription,
      descriptionTectag,
    } = this.state;
    if (!product.soneparId) {
      this.setState({ success: '', message: I18n.t('selectProduct') });
    } else if (!category) {
      this.setState({ success: '', message: I18n.t('selectCategory') });
    } else if (!description) {
      this.setState({ success: '', message: I18n.t('selectDescription') });
    } else {
      try {
        await this.props.saveProduct({
          soneparId: product.soneparId,
          spotlight,
          isSpot,
          categoryId: category.id,
          brandId,
          description,
          code: product.code,
          isDisable,
          brandTectag,
          otherBrand,
          otherDescription,
          descriptionTectag,
        });
        this.setState({
          success: I18n.t('productAdded'),
          value: '',
          product: {
            soneparId: '',
            code: '',
          },
          brandId: '',
          description: '',
          message: '',
          category: '',
          spotlight: false,
          isSpot: false,
          isDisable: false,
          otherBrand: false,
          brandName: I18n.t('selectBrand'),
          categoryName: I18n.t('selectCategory'),
          otherDescription: false,
          descriptionTectag: '',
        });
      } catch (err) {
        if (err.response && err.response.data.error.code === 701) {
          this.setState({ success: '', message: I18n.t('tectagProductNotFound') });
        } else if (err.response && err.response.data.error.code === 702) {
          this.setState({ success: '', message: I18n.t('tectagProductBrandNotFound') });
        } else {
          this.setState({ success: '', message: I18n.t('errorOcurred') });
        }
      }
    }
  };

  selectCheckItem = (attr) => {
    const product = this.state;
    product[attr] = !product[attr];
    this.setState({ ...product });
  };

  setOtherBrand = (otherBrand) => {
    const state = this.state;

    state.otherBrand = otherBrand;
    if (otherBrand === false) {
      state.brandId = state.brandTectag;
    }

    this.setState({ ...state });
  };

  setOtherDescription = (otherDescription) => {
    const state = this.state;

    state.otherDescription = otherDescription;
    if (otherDescription === false) {
      state.description = state.descriptionTectag;
    }

    this.setState({ ...state });
  };

  setBrand = (brandId) => {
    this.setState({ brandId, message: '', success: '' });
  };

  getBrands = brands => brands.map(brand => (
    <option key={brand.id} value={brand.id}>{brand.description}</option>
  ));

  render() {
    const {
      value,
      product,
      brandId,
      description,
      message,
      success,
      brandName,
      categoryName,
      isSpot,
      spotlight,
      isDisable,
      otherBrand,
      otherDescription,
      descriptionTectag,
    } = this.state;
    const {
      searched, categories, brands, productComming, companyTag
    } = this.props;

    return (
      <div className="form-main">
        <h2 className="header-form-client"><Translate value="productRegister" /></h2>
        <form>

          <div className="form-group search-custom-input">
            <p className="margin-bottom-2"><Translate value="product" /></p>
            {productComming ? (
              <input
                type="text"
                value={`${product.soneparId} - ${product.name}`}
                className="form-control"
                aria-describedby="botãoComprar"
                disabled
              />
            ) : (
              <Autocomplete
                getItemValue={item => this.setSelectedProduct(item)}
                items={searched || []}
                className="custom-select"
                maxLength={FIELDS.max}
                renderItem={(item, isHighlighted) => (
                  <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                    {item.code}
                    {' '}
                    {item.tacTagId.descriptionLarge}
                    {' '}
                    {item.tacTagId.narrative}
                  </div>
                )}
                value={value}
                onChange={e => this.setOnChange(e.target.value)}
                onSelect={e => this.setSelectedProductId({ value: e })}
              />
            )}

          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="category" /></p>
            <select className="custom-select" onChange={e => this.setCategory(e.target.value)} required>
              <option value={product.soneparId}>{categoryName}</option>
              {categories && this.getCategories(categories)}
            </select>
            <div className="invalid-feedback"><Translate value="selectBrand" /></div>
          </div>
          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="branchTectag" /></p>
            <input
              type="text"
              value={brandName}
              disabled
              className="form-control"
              placeholder=""
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="updateBrandTectag" /></p>
            <select
              className="custom-select"
              required
              value={otherBrand}
              onChange={e => this.setOtherBrand(e.target.value)}
            >
              {this.getBrandsChangeOptions()}
            </select>
          </div>

          <div className={(otherBrand === false) ? 'form-group d-none' : 'form-group'}>
            <p className="margin-bottom-2"><Translate value="brand" /></p>
            <select
              className="custom-select"
              onChange={e => this.setBrand(e.target.value)}
              required
              value={brandId}
            >
              {brands && this.getBrands(brands)}
            </select>
            <div className="invalid-feedback"><Translate value="selectCategory" /></div>
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="descriptionTectag" /></p>
            <input
              type="text"
              value={descriptionTectag}
              disabled
              className="form-control"
              placeholder=""
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="updateDescriptionTectag" /></p>
            <select
              className="custom-select"
              required
              value={otherDescription}
              onChange={e => this.setOtherDescription(e.target.value)}
            >
              {this.getDescriptionChangeOptions()}
            </select>
          </div>

          <div className={(otherDescription === false) ? 'form-group d-none' : 'form-group'}>
            <p className="margin-bottom-2"><Translate value="titleExibition" /></p>
            <input
              type="text"
              value={description}
              className="form-control"
              aria-describedby="botãoComprar"
              placeholder=""
              onChange={e => this.setState({ description: e.target.value, message: '', success: '' })}
              maxLength={FIELDS.max}
            />
            <div className="invalid-feedback"><Translate value="selectCategory" /></div>
          </div>

          <div className="form-check">
            <input
              onClick={() => this.selectCheckItem('isSpot')}
              type="checkbox"
              className="form-check-input"
              checked={!!isSpot}
              id="spotCheck"
            />
            <span>{I18n.t('spot')}</span>
          </div>

          <div className="form-check">
            <input
              onClick={() => this.selectCheckItem('spotlight')}
              type="checkbox"
              className="form-check-input"
              checked={!!spotlight}
              id="spotlightCheck"
            />
            <span><Translate value="spotlight" /></span>
          </div>

          <div className="form-check">
            <input
              onClick={() => this.selectCheckItem('isDisable')}
              type="checkbox"
              className="form-check-input"
              checked={!!isDisable}
              id="isDisableCheck"
            />
            <span><Translate value="disabled" /></span>
          </div>

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>
            {productComming
              ? (
                <button
                  type="button"
                  onClick={() => this.updateProduct()}
                  className="btn btn-dark"
                >
                  <Translate value="update" />
                </button>
              )
              : (
                <button
                  type="button"
                  onClick={() => this.saveProduct()}
                  className="btn btn-dark"
                >
                  <Translate value="save" />
                </button>
              )
            }
          </div>

        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getSearchProducts: (limit, search) => { dispatch(ProductsAction.getSearchProducts(limit, search)); },
  getCategories: () => { dispatch(getCategoriesAction()); },
  getBrands: () => { dispatch(getBrandsAction()); },
  saveProduct: product => dispatch(ProductsAction.saveProduct(product)),
  updateProduct: product => dispatch(ProductsAction.updateProduct(product)),
});

const mapStateToProps = state => ({
  searched: state.products.searched,
  categories: state.categories.categories,
  brands: state.brands.brands,
  companyTag: state.settings && state.settings.companyTag,
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductsFormComponent);
